module.exports = __webpack_public_path__ + "img/Arrow-down.9e3ef1b7.svg";